import { render } from "./PortalChangePassword.vue?vue&type=template&id=61feef5e&scoped=true"
import script from "./PortalChangePassword.vue?vue&type=script&lang=js"
export * from "./PortalChangePassword.vue?vue&type=script&lang=js"

import "./PortalChangePassword.vue?vue&type=style&index=0&id=61feef5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61feef5e"]])

export default __exports__